export default __webpack_public_path__ + "static/image-four-mobile-3f50e36dc6411417a5f696869cdc0fcd.jpg";